import { render, staticRenderFns } from "./Origami.vue?vue&type=template&id=0f596d8b&scoped=true&"
import script from "./Origami.vue?vue&type=script&lang=js&"
export * from "./Origami.vue?vue&type=script&lang=js&"
import style0 from "./Origami.vue?vue&type=style&index=0&id=0f596d8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f596d8b",
  null
  
)

export default component.exports